<template>
  <div>
    <wc-page-title title='Financial Reports'>
      <template v-slot:rightSide>
        <wc-burger-menu>
          <v-list-item @click='changeDate'>
            <v-list-item-icon>
              <v-icon color='info'>mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Change Report Date</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </wc-burger-menu>
      </template>
    </wc-page-title>
    <v-container>
      <bs-report
        v-if='accounts.length > 0'
        :accounts='accounts'
        :net_income='net_income'
        :as_at='as_at'
       ></bs-report>
    </v-container>

    <!-- Date Picker Dialog -->
    <wc-dialog
      :showDialog='showDatePickerDialog'
      title='Change Report Date'
      icon='mdi-calendar'
      width='300'
      @save='saveDateChange'
      @cancel='showDatePickerDialog = false'
      >
      <wc-datepicker
        v-model='new_as_at'
        removeClearOption
      ></wc-datepicker>
    </wc-dialog>
  </div>
</template>

<script>
import bookkeepingAPI from '@/api/accounting';
import _ from 'lodash';
import moment from 'moment';
import BSReport from '@/modules/management/components/financial_reports/BSReport';

export default {
  name: 'balance-sheet',
  data: () => ({
    isLoading: false,
    showDatePickerDialog: false,
    net_income: 0,
    accounts: [],
    as_at: '',
    new_as_at: ''
  }),
  mounted () {
    this.as_at = moment().format('YYYY-MM-DD').toString();
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let tmp = await bookkeepingAPI.getBalanceSheetAccounts(this.as_at);
      this.accounts = _.orderBy(tmp.accounts, 'number');
      this.net_income = tmp.net_income;
      this.isLoading = false;
    },
    changeDate () {
      this.new_as_at = this.as_at;
      this.showDatePickerDialog = true;
    },
    saveDateChange () {
      this.as_at = this.new_as_at;
      this.showDatePickerDialog = false;
      this.getData();
    }
  },
  components: {
    'bs-report': BSReport
  }
}
</script>
